import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Groups } from '@app/client';

import { usersCacheKeys } from './utilities';

// React Hook using React Query useMutation to create a new user invite.
export function useCreateInvite() {
    const client = useQueryClient();

    return useMutation((groupId?: string) => Groups.callCreateInvite({ group_id: groupId }), {
        onSuccess: () => {
            client.invalidateQueries(usersCacheKeys.inviteData);
        },
    });
}
